import { ElementRef, Injectable } from "@angular/core";
import { Broadcaster } from "../../service/Broadcaster";
import { Alert } from "../../class/alert/alert";

@Injectable()
export class AlertService {
    blockContent: boolean = false;
    constructor (private elRef: ElementRef, private broadcaster: Broadcaster){
       
    }
    public onInit () {
        this.elRef.nativeElement.querySelector(".mask-alert").addEventListener(
            "click",
            (event) => {
                if (this.blockContent) {
                    this.Closed();
                }
            }, false);

            this.broadcaster.on<any>("closedAlert").subscribe(data => {
                if (this.elRef.nativeElement.style.display === "block") {
                    this.Closed();
                }
    
            });
    }
    public show (data:Alert){
        this.elRef.nativeElement.querySelector(".alert").style.display = "block";
        this.elRef.nativeElement.querySelector(".alert").classList.add("m--fade");
        if (data.blockContent) {
            this.blockContent = true;
            this.elRef.nativeElement.querySelector(".mask-alert").style.display = "block";
        }
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "block";
        document.body.querySelector("main").classList.add("m--blur");
    }
    public Closed() {
        this.elRef.nativeElement.querySelector(".mask-alert").style.display = "none";
        this.elRef.nativeElement.querySelector(".alert").style.display = "none";
        this.elRef.nativeElement.querySelector(".alert").classList.remove("m--fade");
        if (!this.blockContent) {
            document.body.querySelector("main").classList.remove("m--blur");
            (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "none";
        }
        this.blockContent = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/alert/service/alert.service.ts